// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fxumQ","badges":"styles_badges__1hprU"};